// extracted by mini-css-extract-plugin
export default {"wrapper":"vJ6smB2GNc0mtdVkdXGU"};